import { Tooltip } from "../plugin/tooltip";
export const init_actions_tooltips = () => {
    document.querySelectorAll('.cpac_use_icons').forEach((el) => {
        el.parentElement.querySelectorAll('.row-actions a').forEach((el) => {
            new Tooltip(el, el.innerText);
        });
    });
};
